import React from "react";
import logo from "../../assets/footer_logo.png";
import mastermind from "../../assets/mm.png";   // ⭐ IMPORTED
import "./Footer.scss";
import { FaFacebookF, FaInstagram, FaTwitter, FaYoutube, FaPinterest } from "react-icons/fa";
import { Link } from "react-router-dom";
import call from "../../assets/footer/calling.png";
import time from "../../assets/footer/time.png";
import location from "../../assets/footer/location.png";
import clinicspot from "../../assets/clinicspot.png";

const Footer = () => {
  const footerMenu = [
    { name: "About", link: "/#clinic" },
    { name: "Services", link: "/#services" },
    { name: "Dentist", link: "/#dentist" },
    { name: "Team", link: "/#associates" },
    { name: "Gallery", link: "/#gallery" },
    { name: "Testimonials", link: "/#testimonials" },
    { name: "Contact", link: "/#contact" },
  ];

  const footerContacts = [
    {
      title: "Phone Number",
      info: (
        <>
          9035289171 <br /> 080 4208 3115
        </>
      ),
      icon: call,
    },
    {
      title: "Open Hours",
      info: "10:00 AM - 11:00 PM",
      icon: time,
    },
    {
      title: "Clinic Address",
      info:
        "1175, 24th Main Rd, near Shri Maramma Devi Devasthana, Garden Layout, Sector 2, HSR Layout, Bengaluru, Karnataka 560102",
      icon: location,
    },
  ];

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">

          {/* About */}
          <div className="footer-section">
            <div className="footer-logo">
              <img src={logo} alt="logo" />
            </div>
            <p>
              Kosmix Dental Clinic in HSR Layout, Bengaluru, offers advanced
              dental care with personalized treatments ensuring precision,
              comfort, and exceptional results.
            </p>

            <div className="social-icons">
              <p>Follow us on:</p>
              <div className="icons">
                <a href="https://www.facebook.com/kosmixhsr" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
                <a href="https://x.com/kosmixhsr" target="_blank" rel="noopener noreferrer"><FaTwitter /></a>
                <a href="https://www.instagram.com/kosmixhsr/" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
                <a href="https://www.youtube.com/@kosmixhsr" target="_blank" rel="noopener noreferrer"><FaYoutube /></a>
                <a href="https://www.pinterest.com/kosmixhsr/" target="_blank" rel="noopener noreferrer"><FaPinterest /></a>

                <a
                  href="https://www.clinicspots.com/dentist/bangalore/hsr-layout"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={clinicspot} alt="ClinicSpot" style={{ width: 20, height: 24 }} />
                </a>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <div className="section-title1">
              <p style={{ marginBottom: "20px" }}>Quick Links</p>
            </div>
            <ul className="footer-links">
              {footerMenu.map((item, index) => (
                <li key={index}>
                  <Link to={item.link}>{item.name}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-section">
            <div className="section-title2">
              <p>Contact & Information</p>
            </div>
            <ul className="footer-contacts">
              {footerContacts.map((item, index) => (
                <li key={index} className="contact-item">
                  <img src={item.icon} alt="icon" className="contact-icon" />
                  <div className="contact-text">
                    <p>{item.title}</p>
                    <h5>{item.info}</h5>
                  </div>
                </li>
              ))}
            </ul>
          </div>

        </div>

        {/* CENTERED LOGO + COPYRIGHT */}
        {/* Bottom */}
        <div className="footer-bottom">

          <div className="footer-designer">
            <p>
              © 2025 Kosmix Dental Clinic. Designed by{" "}
              <a
                href="https://mastermindweb.in/"
                target="_blank"
                rel="noopener noreferrer"
              >
                MasterMind Web Developers
              </a>
            </p>

            {/* Center Logo */}
            <a
              href="https://mastermindweb.in/"
              target="_blank"
              rel="noopener noreferrer"
              className="designer-logo"
            >
              <img src={mastermind} alt="MasterMind Web Developers" />
            </a>
          </div>

        </div>


      </div>
    </footer>
  );
};

export default Footer;
